import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";

import BigGreenCheck from "../../assets/img/new/success.png";
import { makeGetDataAccount } from "../../lib/selector";
import { setDataAccount } from "../client/actions";

import CASCLogo from "../../assets/img/casc_logo.png";
import QRCode from "../../assets/img/qrcode.png";
import ImgAppStore from "../../assets/img/imgAppStore.png";
import ImgGGPlay from "../../assets/img/imgGGPlay.png";
import { Link, useHistory } from "react-router-dom";

function PageSuccess({ dataAccount }) {
  const dispatch = useDispatch();
  const history = useHistory()

  const [accountNo, setAccountNo] = useState(null);

  useEffect(() => {
    if (dataAccount) {
      setAccountNo(dataAccount?.C_ACCOUNT_NO);
      dispatch(setDataAccount(null));
    }
  }, []);

  return (
    <Container>
      <Row>
        <Col lg="10" className="offset-lg-1">
          <div className="content pt180">
            <Link to="/open-account/check-info">
              <img src={CASCLogo} alt="" style={{ height: "75px" }} />
            </Link>
            <h2 className="mt-2 color-casc">Đăng ký tài khoản thành công</h2>
            <div className="icon">
              <img src={BigGreenCheck} alt="" />
            </div>
            <p
              className="text-left w-100 mb-0 fz-16 color-casc"
              style={{ lineHeight: "1.7" }}
            >
              Chúc mừng Quý Khách đã đăng ký thành công{" "}
              <b>Tài Khoản Giao Dịch Chứng Khoán {accountNo}.</b>
            </p>
            <p
              className="text-left w-100 my-0 fz-16 color-casc"
              style={{ lineHeight: "1.7" }}
            >
              Thông tin mật khẩu đăng nhập, mật khẩu đặt lệnh (PIN) đã được gửi
              tới tin nhắn và email của Quý Khách.
            </p>
            <p
              className="text-left w-100 fz-16 color-casc"
              style={{ lineHeight: "1.7" }}
            >
              Quý Khách vui lòng hoàn thiện hồ sơ mở Tài Khoản theo một trong
              những hình thức xác thực sau đây:
            </p>
            <div className="w-100 fz-16 color-casc mt-3 d-flex flex-column">
              <b>1. Xác thực Khách hàng điện tử eKYC</b>
              <span>
                Quý Khách đăng nhập tài khoản trên ứng dụng điện thoại để thực
                hiện xác thực eKYC.
              </span>
              <span>Tải ứng dụng hoặc quét mã QR code:</span>
            </div>

            <div className="w-100 my-3 d-flex align-items-center justify-content-center">
              <div className="d-grid" style={{ gap: "15px" }}>
              <a
                    target={"_blank"}
                    href="https://apps.apple.com/vn/app/casc/id1604708304"
                  >
                    <img src={ImgAppStore} alt="" />
                  </a>
                  <a
                    target={"_blank"}
                    href="https://play.google.com/store/apps/details?id=vn.casc.casc"
                  >
                    <img src={ImgGGPlay} alt="" />
                  </a>
              </div>
              <img
                src={QRCode}
                alt=""
                style={{ height: "88px", marginLeft: "30px" }}
              />
            </div>

            <div className="w-100 fz-16 color-casc mt-3 d-flex flex-column">
              <b>
                2. Hoàn thiện hồ sơ tại Quầy/Gửi hồ sơ về địa điểm làm việc của
                CASC
              </b>
              <ul>
                <li>
                  Quý Khách vui lòng mang theo CMND/CCCD còn hiệu lực tới các
                  địa điểm làm việc của CASC để hoàn thiện hồ sơ mở tài khoản.
                </li>
                <li>
                  Trường hơp gửi hồ sơ từ xa, Quý Khách vui lòng gửi kèm đề nghị
                  xác thực chữ ký do UBND Phường/Xã hoặc văn phòng công chứng
                  xác nhận.
                </li>
              </ul>
            </div>

            <div className="w-100 fz-16 color-casc mt-3 d-flex flex-column">
              <b>3. Hệ thống giao dịch trực tuyến</b>
              <ul>
                <li>
                  Webtrading:{" "}
                  <a
                    target={"_blank"}
                    className="fs-i font-weight-bold"
                    style={{ textDecoration: "underline" }}
                    href="https://trading.casc.vn"
                  >
                    https://trading.casc.vn
                  </a>
                </li>
                <li>
                  Mobile trading:{" "}
                  <a
                    target={"_blank"}
                    className="fs-i font-weight-bold"
                    style={{ textDecoration: "underline" }}
                    href="https://apps.apple.com/vn/app/casc/id1604708304"
                  >
                    IOS
                  </a>{" "}
                  /{" "}
                  <a
                    target={"_blank"}
                    className="fs-i font-weight-bold"
                    style={{ textDecoration: "underline" }}
                    href="https://play.google.com/store/apps/details?id=vn.casc.casc"
                  >
                    ANDROID
                  </a>
                </li>
              </ul>
            </div>

            <Row
                className="justify-content-center mt-2 mb-5"
                style={{ gridColumn: "1/4" }}
              >

                <Button className="btn-next" onClick={() => window.location.href = 'https://trading.casc.vn/'}>
                  HOÀN THÀNH
                </Button>
              </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

const mapStateToProps = (state) => {
  const getDataAccount = makeGetDataAccount();

  return {
    dataAccount: getDataAccount(state),
  };
};

export default connect(mapStateToProps)(PageSuccess);
